module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Les lieux rencontrés")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t6"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Par ordre de parution dans le texte")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_vm._v("Plymouth : ville située au sud-ouest de l’Angleterre, à 350 km de Londres, à l’embouchure de deux fleuves qui se rejoignent pour former un port naturel.")]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_vm._v("Spithead : bras de mer qui sépare l’île de Wight du reste de l’Angleterre, à proximité de Portsmouth. Protégée des vents, cette zone est souvent utilisée pour ancrer des navires de la Royal Navy.")]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_vm._v("Lizard Point : En Cornouailles, point le plus au sud d’Angleterre.")]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_vm._v("Torbay : Baie située entre Exeter et Plymouth, dans le sud-ouest de l’Angleterre")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t6"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Les officiers de la Royal Navy")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_vm._v("Amiral de la flotte "), _c('span', {
    staticClass: "t5"
  }, [_vm._v("– le plus haut grade –")]), _vm._v(" amiral, vice-amiral, contre-amiral et commodore : officiers généraux.")]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_vm._v("Capitaine, commandant, lieutenant-commandant : officiers supérieurs, selon l’importance du bâtiment qu’ils commandent.")]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_vm._v("Lieutenant, sous-lieutenant : officiers susceptibles de recevoir le commandement d’un petit navire en cas de besoin, mais ils ne sont pas inscrit sur les listes d’active, aussi doivent-ils encore prouver leur valeur pour espérer un poste ferme.")]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_vm._v("Aspirant : grade d’officier le plus bas, attribué d’office aux jeunes bien-nés qui embarquaient pour la première fois, mais aussi le commencement obligatoire de toute carrière navale.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t6"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Les navires")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_vm._v("Brick : deux mâts taillé pour la course en mer et le convoyage.")]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_vm._v("Corvette : petit navire de guerre, léger et rapide, qui apparaît en France à la fin du XVIIe siècle.")]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_vm._v("Frégate : bâtiment de guerre, rapide et manœuvrier, plus grand et mieux armé qu’une corvette.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47c385e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/005.vue
// module id = 66
// module chunks = 0